  import React, { useState, useEffect } from "react";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import {
    faArrowLeft,
    faArrowRight,
    faHome,
    faPlus,
    faThumbsUp,
    faTrash,
  } from "@fortawesome/free-solid-svg-icons";
  import {
    Container,  
    Col,
    Row,
    Card,
    Form,
    Button,
    Breadcrumb,
    Nav,
    Tab,
  } from "@themesberg/react-bootstrap";
  import axios from "axios";
  import { Link, useHistory, useLocation, useParams } from "react-router-dom";
  import UpdateApplicationStatus from "../../components/UpdateApplicationStatus";
  import { Routes } from "../../routes";
  import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
  import BASE_URL from "../../config";



  const ViewApplication = () => {
    
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");
    const [message, setMessage] = useState(null);
    const [activeTab, setActiveTab] = useState("Merchant"); // State to manage active tab
    const { id } = useParams();
    const [applicationData, setApplicationData] = useState({});
    const [loading, setLoading] = useState(true);
    const [inputList, setInputList] = useState([{ attachment: "" }]);
    const [userType, setUserType] = useState(null);
    const [userId, setUserId]= useState (null);
    const history = useHistory();
  

    



    useEffect(() => {
      const messageContainer = document.getElementById("messageContainer");
      if (messageContainer) {
        messageContainer.scrollTop = messageContainer.scrollHeight;
        
      }
    }, [messages]);




  

    // Get user information from localStorage
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem("authToken"));
      if (user) {
        setUserId(user.id);
        setUserType(user.user_type);
      }
    }, []);

  




    // Handle sending new messages
  const handleSendMessage = async () => {
    if (newMessage.trim()) {
      // Create a temporary message object for immediate UI rendering
      const tempMessage = {
        id: Date.now(), // Temporary unique ID for the message
        text: newMessage,
        time: new Date(), // Current timestamp
        sender: true, // Defaulting sender to true for user messages
      };

      // Optimistically update the UI
      setMessages((prevMessages) => [...prevMessages, tempMessage]);
      setNewMessage(""); // Clear the input after sending

      try {
        const response = await axios.post(`${BASE_URL}/api.php`, {
          type: "AddMessage",
          user_id: userId,
          message: newMessage,
          application_id: applicationData.id,
          loggedInUserId:userId
        });

        if (response.data.status === "success") {
          // Update the message ID with the one returned by the backend
          setMessages((prevMessages) =>
            prevMessages.map((msg) =>
              msg.id === tempMessage.id
                ? { ...msg, id: response.data.message_id }
                : msg
            )
          );

          // Handle sending notifications
          try {
            const usersResponse = await axios.get(`${BASE_URL}/api.php?type=users`);
            const allUsers = Array.isArray(usersResponse.data)
              ? usersResponse.data
              : [];

            const targetEmails =
              userType == 2
                ? allUsers
                    .filter(
                      (user) => user.user_type === "0" || user.user_type === "1"
                    )
                    .map((user) => user.email)
                : [applicationData.user_email]; // For userType 0 or 1, use the applicant's email

            for (const email of targetEmails) {
              const notificationPayload = {
                type: "AddNotification",
                email: email,
                title: `New Message In Application id ${applicationData.id}`,
                message: newMessage,
              };

              await axios.post(`${BASE_URL}/api.php`, notificationPayload);
            }

            // alert("Notifications sent successfully!");
          } catch (error) {
            console.error("Error sending notifications:", error);
            alert("Error sending notifications.");
          }
        } else {
          alert(response.data.error || "Failed to add the message.");
          // Remove the temporary message from the UI
          setMessages((prevMessages) =>
            prevMessages.filter((msg) => msg.id !== tempMessage.id)
          );
        }
      } catch (error) {
        console.error("Error sending message:", error);
        alert("Error sending the message.");
        // Remove the temporary message from the UI
        setMessages((prevMessages) =>
          prevMessages.filter((msg) => msg.id !== tempMessage.id)
        );
      }
    }
  };


    // const fetchMessages = async () => {
    //   try {
    //     // console.log(userId,applicationData.user_email);
        
    //     // Check if userId and applicationData.user_email are available before making API call
    //     if (!userId || !applicationData.user_email) {
    //       console.error("userId or user_email is missing.");
    //       return;
    //     }
    
    //     const response = await axios.post(`${BASE_URL}/api.php`, {
    //       type: "GetMessagesByUsers",
    //       loggedin_user_id: userId,
    //       application_id:applicationData.id // No changes here

    //     });
    

    //     // console.log(response.data.applicant_user_messages);
    //     // console.log(response.data.loggedin_user_messages);

    //     // console.log(response.data)
        
    //     if (response.data.status === "success") {
    //       const messages = response.data.messages.map((msg) => ({
    //         id: msg.id,
    //         text: msg.message,
    //         time: new Date(msg.created_at), // Store actual date object for sorting
    //         sender: msg.user_id === userId, // Defaults to false if condition is not met
    //       }));
          

          
    //       // const applicantMessages = response.data.applicant_user_messages.map((msg) => ({
    //       //   id: msg.id,
    //       //   text: msg.message,
    //       //   time: new Date(msg.created_at), // Store actual date object for sorting
    //       //   sender: false, // Marking as sent by the applicant
    //       // }));
    
    //       // Combine messages
          
    //     //  const message = data.response.messages
    //       // const allMessages = [
    //       //   ...loggedinMessages,
    //       //   ...applicantMessages,
    //       // ];
    
    //       setMessages((prevMessages) => {
    //         const allMessages = [...prevMessages, ...messages];
    //         // Sort messages by time in ascending order
    //         allMessages.sort((a, b) => a.time - b.time);
    //         return allMessages;
    //       });
          
    //     } else {
    //       console.error(response.data.error || "Failed to fetch messages.");
    //       alert("Failed to fetch messages.");
    //     }
    //   } catch (error) {
    //     console.error("Error fetching messages:", error);
    //     alert("Error fetching messages.");
    //   } finally {
    //     setLoading(false);
    //   }
    // };


    
    
      


      const fetchMessages = async () => {
        try {
          if (!userId || !applicationData.id) {
            console.error("userId or application ID is missing.");
            return;
          }
      
          const response = await axios.post(`${BASE_URL}/api.php`, {
            type: "GetMessagesByUsers",
            loggedin_user_id: userId,
            application_id: applicationData.id,
          });
      
          if (response.data.status === "success") { 
            const messages = response.data.messages.map((msg) => ({
              id: msg.id,
              text: msg.message,
              time: new Date(msg.created_at),
              sender: msg.sender === userId, // Check if the logged-in user is the sender
              senderName: msg.sender_name || "Unknown", // Include the sender_name
            }));
      
            setMessages((prevMessages) => {
              const allMessages = [...prevMessages, ...messages];
              allMessages.sort((a, b) => a.time - b.time); // Sort messages by time
              
              return allMessages;
            });

            
          } else {
            console.error(response.data.error || "Failed to fetch messages.");
            alert("Failed to fetch messages.");
          }
        } catch (error) {
          console.error("Error fetching messages:", error);
          alert("Error fetching messages.");
        } finally {
          setLoading(false);
        }
      };


      // useEffect(() => {
      //   console.log("Messages state updated:", messages); // Log whenever `messages` changes
      // }, [messages]);
      

    
    

    useEffect(() => {
      // console.log(applicationData);
      if (!userId || !applicationData.user_email) {
        // console.error("userId or user_email is missing.");
        return; // Don't fetch if either value is missing
      }
    
      fetchMessages(); // Only call fetchMessages when both values are available
    }, [userId, applicationData.user_email]);


    const handleKeyPress = (event) => {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault(); // Prevent adding a newline
        handleSendMessage();
      }
    };


    const [statusUpdated, setStatusUpdated] = useState(false);

    // Callback to handle status update
    const handleStatusUpdate = () => {
      setStatusUpdated(true);
    };






    const formatMessages = (messages) => {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
    
      const groupedMessages = [];
    
      let currentGroup = null;
    
      messages.forEach((message) => {
        const messageDate = new Date(message.time);
        let groupDate = '';
    
        // Check if the message is from today, yesterday, or earlier
        if (isSameDay(messageDate, today)) {
          groupDate = 'Today';
        } else if (isSameDay(messageDate, yesterday)) {
          groupDate = 'Yesterday';
        } else {
          groupDate = messageDate.toLocaleDateString(); // Show actual date for older messages
        }
    
        // If the group doesn't exist, create a new one
        if (!currentGroup || currentGroup.date !== groupDate) {
          if (currentGroup) groupedMessages.push(currentGroup);
          currentGroup = { date: groupDate, messages: [] };
        }
    
        currentGroup.messages.push(message);
      });
    
      if (currentGroup) groupedMessages.push(currentGroup); // Add the last group
    
      return groupedMessages;
    };
    
    // Helper function to check if two dates are on the same day
    const isSameDay = (date1, date2) => {
      return date1.getDate() === date2.getDate() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getFullYear() === date2.getFullYear();
    };
    












    // Fetch application data based on the ID
    useEffect(() => {
      const fetchApplicationData = async () => {
        try {
          const response = await axios.get(
            `${BASE_URL}/api.php?type=getApplicationById&id=${id}`
          );
          // console.log(response.data);
          
          setApplicationData(response.data);
          setLoading(false); // Set loading to false after data is fetched
        } catch (error) {
          console.error("Error fetching application data:", error);
          setLoading(false); // Set loading to false on error
        }
      };

      fetchApplicationData();
    }, [id,statusUpdated]); // Dependency on id to re-fetch data when id changes

    // Function to handle switching to the next tab
    const handleNextClick = () => {
      switch (activeTab) {
        case "Merchant":
          setActiveTab("Company");
          break;
        case "Company":
          setActiveTab("Website");
          break;
        case "Website":
          setActiveTab("Manager");
          break;
        case "Manager":
          setActiveTab("Customer");
          break;
        case "Customer":
          setActiveTab("Processing");
          break;
        case "Processing":
          setActiveTab("Transaction");
          break;
        case "Transaction":
          setActiveTab("Bank");
          break;
        case "Bank":
          setActiveTab("Other");
          break;
        case "Other":
          setActiveTab("Merchant"); // Cycling back to the first tab
          break;
        default:
          setActiveTab("Merchant");
          break;
      }
    };

    // Function to handle switching to the previous tab
    const handlePreviousClick = () => {
      switch (activeTab) {
        case "Company":
          setActiveTab("Merchant");
          break;
        case "Website":
          setActiveTab("Company");
          break;
        case "Manager":
          setActiveTab("Website");
          break;
        case "Customer":
          setActiveTab("Manager");
          break;
        case "Processing":
          setActiveTab("Customer");
          break;
        case "Transaction":
          setActiveTab("Processing");
          break;
        case "Bank":
          setActiveTab("Transaction");
          break;
        case "Other":
          setActiveTab("Bank");
          break;
        case "Merchant":
        default:
          setActiveTab("Other"); // Cycling back to the last tab
          break;
      }
    };

    // handle input change
    const handleInputChange = (e, index) => {
      const { name, value } = e.target;
      const list = [...inputList];
      list[index][name] = value;
      setInputList(list);
    };

    // handle click event of the Remove button
    const handleRemoveClick = (index) => {
      const list = [...inputList];
      const remove = list.filter((_, indexFilter) => !(indexFilter === index));
      // list.splice(index, 1);
      alert("Are you want to sure delete this element");
      setInputList(remove);
    };

    // handle click event of the Add button
    const handleAddClick = () => {
      setInputList([...inputList, { attachment: "" }]);
    };
  


    return (
      <>


        {/* Breadcrumb and title */}
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mt-4">
          <div className="d-block mb-4 mb-md-0">
            <Breadcrumb
              className="d-none d-md-inline-block"
              listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
            >
              <Breadcrumb.Item>
                <Link to={"/dashboard/overview"}><FontAwesomeIcon icon={faHome} /></Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item active>View Application</Breadcrumb.Item>
            </Breadcrumb>
            <h4>View Application</h4>
          </div>
        </div>

        {/* Main card container */}
        <Card border="light" className="bg-white  mb-4">
          <Card.Body>
            {/* Tab navigation and content */}
            <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
              <Row>
                {/* Left sidebar with tabs */}
                <Col lg={3}>
                  <Nav fill variant="pills" className="flex-column vertical-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="Merchant">
                        Merchant Application Status
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Company">Company Information</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Website">Website Information</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Manager">
                        Manager Owner Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Customer">
                        Customer Service Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Processing">
                        Processing History
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Transaction">
                        Transaction Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Bank">Bank Information</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Other">Other Information</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>

                {/* Right content area */}
                <Col lg={9}>
                  <Tab.Content>
                    {/* Merchant tab content */}
                    <Tab.Pane eventKey="Merchant">
                      <Form>
                        <Row>
                          <Col md={3} className="mb-3">
                            <Form.Group className="mb-3">
                              <Form.Label>Merchant</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">
                            {applicationData.user_type == 1 ? "admin" : "manager"}
                          </Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="application">
                              <Form.Label>Application Status</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">
                            {/* Render the current application status */}
                            {(() => {
                              switch (applicationData.application_status) {
                                case "0":
                                  return "Application Approved";
                                case "1":
                                  return "Application Declined";
                                case "2":
                                  return "Application Suspended";
                                case "3":
                                  return "Incomplete Application";
                                case "4":
                                  return "Waiting For Merchant";
                                case "5":
                                  return "Waiting For Bank";
                                case "6":
                                  return "Waiting For Agent";
                                case "7":
                                  return "Application Applied";
                                default:
                                  return "Unknown Status"; // In case there's an unexpected value
                              }
                            })()}
                          </Col>

                          <hr />
                          <div className="mt-3 text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </div>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Company tab content */}
                    <Tab.Pane eventKey="Company">
                      <Form>
                        {/* Add more fields as needed */}

                        <Row>
                          <Col md={3} className="mb-3">
                            <Form.Group id="Name">
                              <Form.Label>Company Name</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.company_name}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="Address">
                              <Form.Label>Company Address</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.company_address}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="City">
                              <Form.Label>Company City/Town</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.company_city}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="State">
                              <Form.Label>Company State</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.company_state}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="Zipcode">
                              <Form.Label>Company Zipcode</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.company_zipcode}</Col>
                          <Col md={3} className="mb-4">
                            <Form.Group id="Country">
                              <Form.Label>Company Country</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.company_country}</Col>
                          <hr />
                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Website tab content */}
                    <Tab.Pane eventKey="Website">
                      <Form>
                        <Row>
                          {/* Website information fields */}
                          <Col md={3} className="mb-3">
                            <Form.Group id="websiteurl">
                              <Form.Label>Website URL</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.website_url}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="Address">
                              <Form.Label>Product/Service</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.product}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="Descriptor">
                              <Form.Label>Descriptor</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.descriptor}</Col>
                          <hr />

                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Manager tab content */}
                    <Tab.Pane eventKey="Manager">
                      <Form>
                        {/* Manager information fields */}

                        <Row>
                          <Col md={3} className="mb-3">
                            <Form.Group id="FullName">
                              <Form.Label>Full Name</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.manager_full_name}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="MAddress">
                              <Form.Label> Address</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.manager_address}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="Citytown">
                              <Form.Label> City/Town</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.manager_city}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="MState">
                              <Form.Label> State</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.manager_state}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="MZipcode">
                              <Form.Label>Company Zipcode</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.manager_zipcode}</Col>
                          <Col md={3} className="mb-4">
                            <Form.Group id="Cellphone">
                              <Form.Label>Cell Phone</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.manager_phone}</Col>
                          <Col md={3} className="mb-4">
                            <Form.Group id="Alternatephone">
                              <Form.Label>Alternate Phone</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.manager_AltPhone}</Col>
                          <Col md={3} className="mb-4">
                            <Form.Group id="Emailadd">
                              <Form.Label>Email Address</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.manager_email}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="Skypeid">
                              <Form.Label>Skype Id</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.manager_skype_id}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="Passportid">
                              <Form.Label>Passport / Driver ID#</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.manager_passport}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="ssnein">
                              <Form.Label>SSN / EIN</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.SSN}</Col>
                          <hr />
                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Customer tab content */}
                    <Tab.Pane eventKey="Customer">
                      <Form>
                        {/* Customer information fields */}

                        <Row>
                          <Col md={3} className="mb-3">
                            <Form.Group id="contactname">
                              <Form.Label>Contact Name</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.contactname}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="tollfreeno">
                              <Form.Label>Toll Free Number</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.tollfreeno}</Col>
                          <Col md={3} className="mb-3">
                            <Form.Group id="contactemail">
                              <Form.Label>Contact Email</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={8} className="mb-3">{applicationData.contactemail}</Col>
                          <hr />
                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Processing tab content */}
                    <Tab.Pane eventKey="Processing">
                      <Form>
                        {/* Processing information fields */}

                        <Row>
                          <Col md={5} className="mb-3">
                            <Form.Group id="merchants">
                              <Form.Label>
                                Do You Currently Accept Credit Cards
                              </Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          {/* <Col md={6} className="mb-3">{applicationData.credit_card}</Col> */}
                          <Col md={6} className="mb-3">{applicationData.credit_card == 1 ? 'yes' :'no' }</Col>
                          <Col md={5} className="mb-3">
                            <Form.Group id="merchants">
                              <Form.Label>
                                Have You Ever Processed Before
                              </Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={6} className="mb-3">{applicationData.processed_before == 1 ? 'yes' :'no' }</Col>
                          <Col md={5} className="mb-3">
                            <Form.Group id="merchants">
                              <Form.Label>
                                Have You Ever Had Merchant Account Terminated
                              </Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={6} className="mb-3">{applicationData.merchant_account_termination_status == 1 ? 'yes':'no'}</Col>
                          <Col md={5} className="mb-3">
                            <Form.Group id="contactname">
                              <Form.Label>
                                If Yes Please State The Reason
                              </Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={6} className="mb-3">{applicationData.merchant_account_termination_reason}</Col>
                          <Col md={5} className="mb-3">
                            <Form.Group id="tollfreeno">
                              <Form.Label>Former / Current Processor</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={6} className="mb-3">{applicationData.processor}</Col>
                          <Col md={5} className="mb-3">
                            <Form.Group id="contactemail">
                              <Form.Label>Time With Processor</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={6} className="mb-3">{applicationData.time_with_processor}</Col>

                          <hr />
                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Transaction tab content */}
                    <Tab.Pane eventKey="Transaction">
                      <Form>
                        {/* Transaction information fields */}

                        <Row>
                          <Col md={4} className="mb-3">
                            <Form.Group id="websiteurl">
                              <Form.Label>Estimated Total Sales/Month</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={7} className="mb-3">{applicationData.total_sales}</Col>
                          <Col md={4} className="mb-3">
                            <Form.Group id="Address">
                              <Form.Label>
                                Number Of Transactions/Month
                              </Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={7} className="mb-3">{applicationData.no_of_trans_per_mnth}</Col>
                          <Col md={4} className="mb-3">
                            <Form.Group id="Descriptor">
                              <Form.Label>Minimum Ticket Amount</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={7} className="mb-3">{applicationData.minimum_ticket_amount}</Col>
                          <Col md={4} className="mb-3">
                            <Form.Group id="Descriptor">
                              <Form.Label>Maximum Ticket Amount</Form.Label>
                            </Form.Group>
                          </Col>
                          <Col md={1} className="mb-3">
                            :
                          </Col>
                          <Col md={7} className="mb-3">{applicationData.maximum_ticket_amount}</Col>
                          <hr />
                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />{" "}
                              Previous
                            </Button>
                          </Col>
                          <Col md={6} className="text-end">
                            <Button variant="primary" onClick={handleNextClick}>
                              Next{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Bank tab content */}
                    <Tab.Pane eventKey="Bank">
                      <Form>
                        <Row>

                          <Col md={4} className="mb-3">
                            <Form.Label>Account Holder Name</Form.Label>
                          </Col>
                          <Col md={1} className="mb-3">:</Col>
                          <Col md={7} className="mb-3">
                            {applicationData.account_holder_name || "-"}
                          </Col>

                          <Col md={4} className="mb-3">
                            <Form.Label>Account Holder Address</Form.Label>
                          </Col>
                          <Col md={1} className="mb-3">:</Col>
                          <Col md={7} className="mb-3">
                            {applicationData.account_holder_address || "-"}
                          </Col>

                          <Col md={4} className="mb-3">
                            <Form.Label>Account Holder Country</Form.Label>
                          </Col>
                          <Col md={1} className="mb-3">:</Col>
                          <Col md={7} className="mb-3">
                            {applicationData.account_holder_country || "-"}
                          </Col>

                          <Col md={4} className="mb-3">
                            <Form.Label>Bank Name</Form.Label>
                          </Col>
                          <Col md={1} className="mb-3">:</Col>
                          <Col md={7} className="mb-3">
                            {applicationData.bank_name || "-"}
                          </Col>

                          <Col md={4} className="mb-3">
                            <Form.Label>Bank Address</Form.Label>
                          </Col>
                          <Col md={1} className="mb-3">:</Col>
                          <Col md={7} className="mb-3">
                            {applicationData.bank_address || "-"}
                          </Col>

                          <Col md={4} className="mb-3">
                            <Form.Label>Bank Country</Form.Label>
                          </Col>
                          <Col md={1} className="mb-3">:</Col>
                          <Col md={7} className="mb-3">
                            {applicationData.bank_country || "-"}
                          </Col>

                          <Col md={4} className="mb-3">
                            <Form.Label>Bank SWIFT</Form.Label>
                          </Col>
                          <Col md={1} className="mb-3">:</Col>
                          <Col md={7} className="mb-3">
                            {applicationData.bank_swift || "-"}
                          </Col>

                          <Col md={4} className="mb-3">
                            <Form.Label>Bank Routing Number</Form.Label>
                          </Col>
                          <Col md={1} className="mb-3">:</Col>
                          <Col md={7} className="mb-3">
                            {applicationData.bank_routing_no || "-"}
                          </Col>

                          <Col md={4} className="mb-3">
                            <Form.Label>Bank Account Number</Form.Label>
                          </Col>
                          <Col md={1} className="mb-3">:</Col>
                          <Col md={7} className="mb-3">
                            {applicationData.bank_account_number || "-"}
                          </Col>

                          <Col md={4} className="mb-3">
                            <Form.Label>Additional Information</Form.Label>
                          </Col>
                          <Col md={1} className="mb-3">:</Col>
                          <Col md={7} className="mb-3">
                            {applicationData.bank_additional_info || "-"}
                          </Col>

                          <hr />

                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />
                              Previous
                            </Button>
                          </Col>

                          <Col md={6} className="text-end">
                            <Button
                              variant="primary"
                              onClick={handleNextClick}
                            >
                              Next
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="ml-2"
                              />
                            </Button>
                          </Col>

                        </Row>
                      </Form>
                    </Tab.Pane>

                    {/* Other tab content */}
                    <Tab.Pane eventKey="Other">
                      <Form>
                        <Row>

                          <Col md={4} className="mb-3">
                            <Form.Label>How Did You Hear About Us?</Form.Label>
                          </Col>

                          <Col md={1} className="mb-3">
                            :
                          </Col>

                          <Col md={7} className="mb-3">
                            {applicationData.about_us || "-"}
                          </Col>

                          <Col md={4} className="mb-3">
                            <Form.Label>Name Of Agent</Form.Label>
                          </Col>

                          <Col md={1} className="mb-3">
                            :
                          </Col>

                          <Col md={7} className="mb-3">
                            {applicationData.agent_name || "-"}
                          </Col>

                          <hr />

                          <Col md={6}>
                            <Button
                              variant="primary"
                              onClick={handlePreviousClick}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="me-1"
                              />
                              Previous
                            </Button>
                          </Col>

                          <Col md={6} className="text-end">
                            <Button
                              variant="primary"
                              onClick={handleNextClick}
                            >
                              Finish
                              <FontAwesomeIcon
                                icon={faThumbsUp}
                                className="ml-2"
                              />
                            </Button>
                          </Col>

                        </Row>
                      </Form>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>

            <hr />
            {/* <Form>
              <Row>
                <Col md={6} className="mb-3">
                  <Form.Group id="application">
                    <Form.Label>Application Status</Form.Label>
                    <Form.Select defaultValue="0">
                      <option value="0">Application Approved</option>
                      <option value="1">Application Declined</option>
                      <option value="2">Application Suspended</option>
                      <option value="3">Incomplete Application</option>
                      <option value="4">Waiting For Merchant</option>
                      <option value="5">Waiting For Bank</option>
                      <option value="4">Waiting For Agent</option>
                      <option value="4">Application Applied</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={3} className="mt-5 mb-3">
                  <Form.Check
                    label="Send Auto Reply Message"
                    id="checkbox1"
                    htmlFor="checkbox1"
                  />
                </Col>
                <Col md={12}>
                  <Button variant="primary">Update Status </Button>
                </Col>
              </Row>
            </Form>
            <hr />
            <Form>
              <Row>
                <Col md={12} className="mb-3">
                  <Form.Group>
                    <Form.Label>Notes</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows="3"
                      placeholder="Notes entered here will not be visible to the merchant"
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Button variant="primary">Save Notes </Button>
                </Col>
              </Row>
            </Form>
            <hr />
            <Form>
              <Row>
                <Col md={12} className="mb-3">
                  <Form.Group>
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows="3"
                      placeholder="(To interact with the applicant please write down your message here)"
                    />
                  </Form.Group>
                </Col>

                {inputList.map((x, i) => {
                  return (
                    <div className="box">
                      <Row>
                        <Col md={9} className="mb-3">
                          <Form.Group>
                            <Form.Control
                              name="attachment"
                              value={x.attachment}
                              type="file"
                              onChange={(e) => handleInputChange(e, i)}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={3} className="mb-3">
                          <div className="btn-box">
                            {inputList.length !== 1 && (
                              <Button
                                className="m-1"
                                onClick={() => handleRemoveClick(i)}
                                variant="outline-danger"
                              >
                                {" "}
                                <FontAwesomeIcon icon={faTrash} />{" "}
                              </Button>
                            )}
                            {inputList.length - 1 === i && (
                              <Button
                                className="ml-2"
                                onClick={handleAddClick}
                                variant="outline-success"
                              >
                                {" "}
                                <FontAwesomeIcon icon={faPlus} />{" "}
                              </Button>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  );
                })}

                <Col md={12}>
                  <Button variant="primary">Submit</Button>
                </Col>
              </Row>
            </Form>
            <hr />
            <Row>
              <Col md={12} className="text-end">
                <Button variant="danger">Delete</Button>
              </Col>
              <Col md={3}>Date / Time</Col>
              <Col md={9}>2024-07-01 12:18:28</Col>
              <Col md={3}>By</Col>
              <Col md={9}>Admin</Col>
              <Col md={3}>Message</Col>
              <Col md={9}>
                Dear Admin,
                <br />
                <br />
                Thanks for Choosing Blueberry as your processing partner!!!
                <br />
                Your application is incomplete kindly update all the field in
                application and you can do so go to application tab and click edit
                button.
                <br />
                <br />
                Below are the list of missing fields:
                <br />
                <ol>
                  <li>
                    Company Information
                    <ul>
                      <li>Company Name</li>
                      <li>Company Address</li>
                      <li>Company City/Town</li>
                      <li>Company State</li>
                      <li>Company Zip Code</li>
                      <li>Company Country</li>
                    </ul>
                  </li>
                  <li>
                    Website Information
                    <ul>
                      <li>Website URL</li>
                      <li>Product / Service</li>
                      <li>Descriptor</li>
                    </ul>
                  </li>
                  <li>
                    Manager / Owner Information
                    <ul>
                      <li>Full Name</li>
                      <li>Address</li>
                      <li>City / Town</li>
                      <li>Sate</li>
                      <li>Zip Code</li>
                      <li>Cell Phone</li>
                      <li>Email Address</li>
                      <li>Skype Id</li>
                      <li>Passport / Driver ID#</li>
                    </ul>
                  </li>
                  <li>
                    Customer Service Information
                    <ul>
                      <li>Contact Name</li>
                      <li>Contact Email</li>
                    </ul>
                  </li>
                  <li>
                    Transaction Information
                    <ul>
                      <li>Estimated Total Sales/Month</li>
                      <li>Number Of Transactions/Month</li>
                      <li>Minimum Ticket Amount</li>
                      <li>Maximum Ticket Amount</li>
                    </ul>
                  </li>
                  <li>
                    Bank Information
                    <ul>
                      <li>Account Holder Name</li>
                      <li>Account Holder Address</li>
                      <li>Account Holder Country</li>
                      <li>Bank Name</li>
                      <li>Bank Address</li>
                      <li>Bank Country</li>
                      <li>Bank SWIFT</li>
                      <li>Bank Account Number</li>
                    </ul>
                  </li>
                </ol>
                <br />
                <br />
                Application Team
                <br />
                Blueberry
              </Col>
            </Row> */}
          </Card.Body>
        </Card>
        <Container
    fluid
    style={{
      padding: "20px",
      backgroundColor: "#fff",
      border: "1px solid #ddd",
      borderRadius: "8px",
    }}
  >
    {/* Displaying Messages */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        maxHeight: "300px", // Restrict height of the message area
        overflowY: "auto", // Enable vertical scrolling
        overflowX: "hidden", // Prevent horizontal scrolling
        backgroundColor: "#f8f9fa",
        borderRadius: "8px 8px 0 0",
        padding: "1rem",
      }}
      id="messageContainer"
    >
    <style>
    {`
  #messageContainer {
    scrollbar-color: #002c55 #e9ecef; /* Thumb and track color for Firefox */
    scrollbar-width: thin; /* Thinner scrollbar */
  }

  #messageContainer::-webkit-scrollbar {
    width: 12px; /* Increase width for better visibility */
  }

  #messageContainer::-webkit-scrollbar-thumb {
    background: #002c55; /* Thumb color */
    border-radius: 20px; /* Add noticeable rounded corners */
    border: 3px solid #e9ecef; /* Add padding to the thumb with a border */
  }

  #messageContainer::-webkit-scrollbar-track {
    background: #e9ecef; /* Track color */
    border-radius: 20px; /* Rounded corners for the track */
  }

    `}
  </style>



      {/* Function to format dates */}
      {formatMessages(messages).map((group, index) => (
            <div key={index}>
              {/* Display date heading */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Center the heading
                  marginBottom: "8px",
                }}
              >
                <div
                  style={{
                    display: "inline-block", // Make the width fit the text only
                    backgroundColor: "#e9ecef",
                    fontWeight: "bold",
                    color: "#6c757d",
                    fontSize: "16px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                  }}
                >
                  {group.date}
                </div>
              </div>
      
              {/* Displaying individual messages in each group */}
              {group.messages.map((message) => (
                
                
                <div
                  key={message.id}
                  style={{
                    display: "flex",
                    justifyContent: message.sender ? "flex-end" : "flex-start",
                    marginBottom: "8px",
                  }}
                >
                  <div
                    style={{
                      padding: "10px",
                      borderRadius: "8px",
                      maxWidth: "75%", // Prevent messages from stretching beyond container width
                      backgroundColor: message.sender ? "#002c55" : "#002c55",
                      color: message.sender ? "#fff" : "#fff",
                      wordWrap: "break-word", // Ensure long words break into the next line
                    }}
                  >


                     {/* {message.sender && (
                     
                      )} */}


                    <p style={{ marginBottom: "0" }}>
                    {message.text}
                    </p>
                    <div style={{display:'flex',gap:'1rem'}}>
                          <small style={{ color: "#6c757d" }}>
                            {new Date(message.time).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })}

                          </small>
                          <small
                                style={{
                                  fontWeight: "bold",
                                  display: "block",
                                  color: "#6c757d"
                                }}
                              >
                                {message.senderName || "Unknown "}
                              </small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}







    </div>

    {/* Input for New Message */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#fff",
        padding: "12px",
        borderTop: "1px solid #ddd",
        borderRadius: "0 0 8px 8px",
      }}
    >
      <input
        type="text"
        placeholder="Type your message..."
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter") handleSendMessage(); // Send on Enter
        }}
        style={{
          flex: 1,
          padding: "10px",
          borderRadius: "4px",
          border: "1px solid #ddd",
        }}
      />
      <button
        onClick={handleSendMessage}
        style={{
          padding: "10px 16px",
          borderRadius: "4px",
          border: "1px solid #007bff",
          backgroundColor: "#002c55",
          color: "#fff",
          marginLeft: "8px",
          cursor: "pointer",
        }}
      >
        Send
      </button>
    </div>
  </Container>




      {userType == 0 || userType == 1 ? (
    <UpdateApplicationStatus
      applicationId={id}
      applicationData={applicationData} // Pass the current application data
      onStatusUpdate={handleStatusUpdate}
    />
  ) : " "}
      
        
      </>
    );
  };

  export default ViewApplication;
